import React from 'react'

import { AppBar, Box, Button, CircularProgress, Toolbar } from '@mui/material'
import { Link, useLocation } from '@redwoodjs/router'

import { useAuth } from 'src/auth'
import { PackningPreviousPeriodNoticeModal } from 'src/components/PackingGuide/PackningPreviousPeriodNoticeModal'
import { buildLoginWithReturnTo } from 'src/lib/auth/packningReturnTo'
import AdminLayout from 'src/layouts/AdminLayout/AdminLayout'

type PackingGuideLayoutProps = {
  children?: React.ReactNode
}

type MinimalPackingChromeProps = PackingGuideLayoutProps & {
  loginPath: string
}

const MinimalPackingChrome = ({ children, loginPath }: MinimalPackingChromeProps) => {
  return (
    <Box sx={{ minHeight: '100vh', bgcolor: 'background.default' }}>
      <AppBar
        position="fixed"
        color="inherit"
        elevation={0}
        sx={{ borderBottom: 1, borderColor: 'divider' }}
      >
        <Toolbar sx={{ justifyContent: 'space-between' }}>
          <Box
            component="a"
            href="https://lagshoppen.se/"
            sx={{ display: 'flex', alignItems: 'center' }}
          >
            <img
              src="/lagshoppen-logo.svg"
              alt="Lagshoppen"
              style={{ height: 25 }}
            />
          </Box>
          <Button component={Link} to={loginPath} variant="outlined">
            Logga in
          </Button>
        </Toolbar>
      </AppBar>
      <Toolbar />
      <Box sx={{ p: 2, maxWidth: 720, mx: 'auto' }}>{children}</Box>
    </Box>
  )
}

const PackingGuideLayout = ({ children }: PackingGuideLayoutProps) => {
  const { pathname, search } = useLocation()
  const { loading, isAuthenticated, hasRole } = useAuth()
  const isAdminPackningPath = pathname.startsWith('/admin/packning')
  const loginPath = buildLoginWithReturnTo(pathname, search)
  const allowed =
    isAuthenticated &&
    (hasRole('lead') ||
      hasRole('member') ||
      (hasRole('admin') && isAdminPackningPath))

  if (loading) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '40vh',
        }}
      >
        <CircularProgress />
      </Box>
    )
  }

  if (!allowed) {
    return <MinimalPackingChrome loginPath={loginPath}>{children}</MinimalPackingChrome>
  }

  return (
    <AdminLayout>
      {!isAdminPackningPath && <PackningPreviousPeriodNoticeModal />}
      {children}
    </AdminLayout>
  )
}

export default PackingGuideLayout
